import {createApp} from 'vue'
import App from './App.vue'
import batch________import from "@/common/imports";


const app = createApp(App);

batch________import(app);
app.mount('#app')
